import React from "react";
import "@xyflow/react/dist/style.css";
import Canvas from "./components/Canvas";

const Workflow: React.FC = () => {
  return (
    <div id="workflow-container" className={"flex flex-col h-screen"}>
      <Canvas className="flex-grow" />
    </div>
  );
};

export default Workflow;
